module.exports = __webpack_public_path__ + "img/ceviche_ready.da7fc816.jpg";